module.exports = __webpack_public_path__ + "img/history-icon.2fddef71.svg";